<template>

<app-content :loading="is.loading">

	<app-content-body v-if="!is.loading" :is-call="true">

		<app-content-call :loading="is.confirming" icon="accept" theme="green" title="Accept Assignment" :text="text" :has-cancel="true" button="Confirm" v-on:click="onConfirmClick" v-on:cancel="onCancelClick">

		</app-content-call>
	
	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
			model: {},
			item: {}
		}

	},

	created: function() {

		this.load();

	},

	computed: {

		text: function() {
		
			return 'The assignment will be accepted and the user will be notified.'
		
		}

	},

	methods: {

		redirectBack: function(defaultName) {
		
			if (this.$route.query.redirect === 'badge') {

				this.$router.push({
					name: 'Convention.Volunteers.Badges.Edit',
					params: {
						id: this.$route.query.badge
					}
				})

			} else {

				this.$router.push({
					name: defaultName
				})
			
			}

		},

		onCancelClick: function() {

			this.redirectBack('Convention.Volunteers.Pending.Edit')

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.post('convention/volunteers/assignment/' + this.$route.params.id + '/accept', this.model).then(function() {

				this.$notify({
					message: 'The submission has been accepted!'
				})

				this.redirectBack('Convention.Volunteers.Confirmed.Edit')

			}.bind(this))

		},

		load: function() {

			this.$api.get('convention/volunteers/assignment/' + this.$route.params.id + '/accept').then(function(response) {

				Vue.set(this, 'item', response.item)
				
				this.is.loading = false

			}.bind(this), function() {
			
				this.$notify({
					message: 'This is not a pending assignment.',
					type: 'error'
				})

				this.redirectBack('Convention.Volunteers.Pending.Edit')
			
			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>
